import { FormDesignPreviewEditForm } from "components/Forms/FormDesignPreviewEditForm/FormDesignPreviewEditForm";
import { DataType } from "components/Tables/FormDesignTable/temp";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

interface EditDrawerProps {
    formId: string;
    onUpdate: (newData: DataType) => void;
    dataSource: DataType[];
}

export const EditDrawer: FC<EditDrawerProps> = ({ onUpdate, formId, dataSource }) => {
    const { t } = usePaldockTranslation("drawers.form-design-preview-edit");
    const id = DrawerId.FormDesignPreviewEdit;
    const { hide } = useDrawer();

    const handleUpdate = async (newData: DataType) => {
        onUpdate(newData);
        hide(id, `${id}-formId`);
    };

    return (
        <Drawer drawerId={id} title={<DrawerTitle mainTitle={t("title")} />} searchParamsToClean={[`${id}-formId`]}>
            {/* TODO: misto toho bude api call formData */}
            <FormDesignPreviewEditForm
                onUpdate={handleUpdate}
                formData={dataSource.find((data) => data.key === formId) as DataType}
            />
        </Drawer>
    );
};
